"use strict";
/*
 * Created on 01 14 2019
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var immutable_1 = require("immutable");

var ObjectUtils_1 = require("../../utils/ObjectUtils");

var StructPropBuilder_1 = require("../data-dictionary/StructPropBuilder");

var DomainObject_1 = require("../DomainObject");

var ResultSeverity_1 = require("./ResultSeverity");

var ValidationResultFlag_1 = require("./ValidationResultFlag");
/**
 * Detailed description of single validation result.
 *
 * @author JMe
 */


var ValidationResultObject =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(ValidationResultObject, _DomainObject_1$Domai);

  // todo JMe change messageVariables to [variableName, variableValue] do not rely on order,
  // possible problems using string value repr.: dates (utc vs. client)

  /**
   * @param severity the action severity
   * @param messageKey localization key for message (should be mandatory)
   * @param messageVariables list of variables values used to populate message.
   * @param userMessage optional localized message to be displayed for a user, can be constructed within both backend and frontend.
   * @param entityId optional identifier of an instance/entity related to result object.
   * @param flags e.g. rendering flags or other classification
   */
  function ValidationResultObject(severity, messageKey) {
    var _this;

    var messageVariables = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : immutable_1.List();
    var userMessage = arguments.length > 3 ? arguments[3] : undefined;
    var entityId = arguments.length > 4 ? arguments[4] : undefined;
    var flags = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : ValidationResultFlag_1.ValidationResultFlag.EMPTY_SET;

    _classCallCheck(this, ValidationResultObject);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ValidationResultObject).call(this));
    _this.severity = severity;
    _this.messageKey = messageKey;
    _this.messageVariables = messageVariables;
    _this.userMessage = userMessage;
    _this.entityId = entityId;
    _this.flags = flags;
    return _this;
  }
  /**
   * @param value variable value
   * @returns new copy of validation result object with added value of variable
   */


  _createClass(ValidationResultObject, [{
    key: "addVariable",
    value: function addVariable(value) {
      return this.copy('messageVariables', this.messageVariables.push(value));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "equals",
    value: function equals(other) {
      if (other instanceof ValidationResultObject) {
        return this.severity === other.severity && this.messageKey === other.messageKey && (this.messageVariables.isEmpty() && other.messageVariables.isEmpty() || this.messageVariables.equals(other.messageVariables));
      } else {
        return false;
      }
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "hashCode",
    value: function hashCode() {
      return ObjectUtils_1.ObjectUtils.hashCode(this.severity.toString() + '_' + this.messageKey + '_' + this.messageVariables.join('_'));
    }
    /**
     * Creates simple message from given severity and message key with possible arguments.
     * @param severity
     * @param messageKey
     * @param messageVariables
     */

  }], [{
    key: "of",
    value: function of(severity, messageKey) {
      var messageVariables = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : immutable_1.List();
      return new ValidationResultObject(severity, messageKey, messageVariables, null, null);
    }
    /**
     * Converter from data-dictionary representation
     */

  }, {
    key: "fromDataDict",
    value: function fromDataDict(mat) {
      return new ValidationResultObject(mat.severity, mat.messageKey, mat.messageVariables, mat.userMessage, mat.entityId);
    }
  }, {
    key: "error",
    value: function error(messageKey) {
      var messageVariables = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : immutable_1.List();
      var userMessage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      var entityId = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
      var flags = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : ValidationResultFlag_1.ValidationResultFlag.EMPTY_SET;
      return new ValidationResultObject(ResultSeverity_1.ResultSeverity.Error, messageKey, messageVariables, userMessage, entityId, flags);
    }
  }, {
    key: "warning",
    value: function warning(messageKey) {
      var messageVariables = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : immutable_1.List();
      var userMessage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      var entityId = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
      var flags = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : ValidationResultFlag_1.ValidationResultFlag.EMPTY_SET;
      return new ValidationResultObject(ResultSeverity_1.ResultSeverity.Warn, messageKey, messageVariables, userMessage, entityId, flags);
    }
  }, {
    key: "info",
    value: function info(messageKey) {
      var messageVariables = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : immutable_1.List();
      var userMessage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      var entityId = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
      var flags = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : ValidationResultFlag_1.ValidationResultFlag.EMPTY_SET;
      return new ValidationResultObject(ResultSeverity_1.ResultSeverity.Info, messageKey, messageVariables, userMessage, entityId, flags);
    }
  }]);

  return ValidationResultObject;
}(DomainObject_1.DomainObject);

exports.ValidationResultObject = ValidationResultObject;

ValidationResultObject.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(ValidationResultObject.name);
  return {
    severity: builder.senum('severity', ResultSeverity_1.ResultSeverity, 'enums/ResultSeverity'),
    messageKey: builder.str('messageKey'),
    messageVariables: builder.listOf(builder.str('messageVariables')),
    userMessage: builder.opt(builder.str('userMessage')),
    entityId: builder.opt(builder.id('entityId')),
    flags: builder.flags('flags', ValidationResultFlag_1.ValidationResultFlag)
  };
}();